import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface CompanyMarkProps {
    ticker: string
    size?: 'sm' | 'md' | 'lg'
    className?: string
}

const CompanyMark = ({ ticker, size = 'md', className }: CompanyMarkProps): ReactNode => {
    const letters = ticker.replace(/[^A-Za-z0-9]/g, '').slice(0, size === 'sm' ? 2 : 3)

    return (
        <span
            aria-hidden='true'
            className={cn(
                'inline-flex shrink-0 items-center justify-center rounded-md border border-border bg-secondary font-mono font-semibold uppercase tracking-tight text-foreground/90',
                size === 'sm' && 'size-7 text-[10px]',
                size === 'md' && 'size-9 text-[11px]',
                size === 'lg' && 'size-12 text-sm',
                className
            )}
        >
            {letters}
        </span>
    )
}

export default CompanyMark
